import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { getOnboardingCallLink } from '../../../self-upgrade.util';

export const WIV_PRICE = 69;
export const WIV_VIDEO_URL = 'https://fast.wistia.com/embed/medias/p6om5icgjx';
export const WIV_ONBOARDING_URL = getOnboardingCallLink(Feature.WEAVE_VERIFY);
